import One from "../images/12.jpg"
import Two from "../images/13.jpg"
import Three from "../images/14.jpg"
import Four from "../images/15.jpg"
import Five from "../images/16.jpg"
import Six from "../images/17.jpg"
import Seven from "../images/18.jpg"
import Eig from "../images/19.jpg"
import Nin from "../images/20.jpg"
import Ten from "../images/21.jpg"
import Levl from "../images/22.jpg"
import Twole from "../images/23.jpg"
import Threele from "../images/24.jpg"
import Fourle from "../images/26.jpg"
import Fivele from "../images/27.jpg"
import Sixle from "../images/28.jpg"
import Sevenle from "../images/29.jpg"
import Eigle from "../images/30.jpg"









const photo = [
    {
        img :One
    },
    {
        img:Two
    },
    {
        img :Three
    },

    {
        img:Six
    },
    {
        img :Seven
    },
    {
        img:Eig
    },
    {
        img :Nin
    },
    {
        img:Ten
    },
    {
        img :Levl
    },
    {
        img:Twole
    },
    {
        img :Threele
    },
    {
        img:Fourle
    },
    {
        img :Fivele
    },
    {
        img:Sixle
    },
    {
        img :Sevenle
    },
    {
        img:Eigle
    },
   
]

export {photo}